import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'images'
const verb = 'get'

export default class OspreyImagesSearchSuggestion extends BaseAction {
    constructor(dataKey) {
        const id = '0042e8b4-7db4-485c-a745-f3ba58f1b8d6'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getSearchSuggestion(params) {
        this.params = Object.assign({
            fields: 'id,name',
            sf: 'name',
            sd: 'asc',
            archived: false
        }, params)

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/images/images-search-suggestion.js